"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowModel = void 0;
class FlowModel {
    constructor() {
        this.pages = [];
    }
}
exports.FlowModel = FlowModel;
